export const QueryLuckyOcbPage = `
fragment PageGenericFragment on PageGeneric {
  frontendPageComponent {
    targetItem {
      ComponentName: field(name: "ComponentName") {
        value
      }
    }
  }
}

fragment branchInfoFragment on OCBInfo {
  key: name
  template: template {
    name
  }
  branchId: field(name: "BranchId") {
    value
  }
  branchName: field(name: "BranchName") {
    value
  }
  branchDistrict {
    targetItem {
      ... on OCBDistrict {
        region {
          targetItem {
            ... on OCBRegion {
              regionName {
                value
              }
            }
          }
        }
        districtName {
          value
        }
      }
    }
  }

  branchAddress: field(name: "BranchAddress") {
    value
  }
}

fragment branchAddressInfoFragment on OCBAddressInfo {
  branchBasicInfo: branchId {
    targetItem {
      ...branchInfoFragment
    }
  }
  addressSupplement {
    value
  }
  latitude {
    value
  }
  longitude {
    value
  }
}
fragment LuckyOCBPageFragment on LuckyOCBPage {
  header: field(name: "HeaderText") {
    value
  }
  pageTitle {
    value
  }
  tableTitle {
    value
  }
  tableFootnote {
    value
  }
  yearColumns{
    value
  }
  data: children {
    ...LuckyOCBRecordFragment
  }
}
fragment LuckyOCBRecordFragment on LuckyOCBRecord {
  key: name
  branchId {
    targetItem {
      ...branchAddressInfoFragment
    }
  }
  yearWinningRecord: field(name: "YearWinningRecord") {
    value
  }
  enabled: field(name: "Enabled") {
    value
  }  
}

query SpecialPage($path: String!, $lang: String!) {
  Content: item(path: $path, language: $lang) {
    key: name
    ...PageGenericFragment
    ...LuckyOCBPageFragment
  }
}
`;
